import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import PaymentPurposeOptions from "../PaymentPurposeOptions";
import StyledFormInput from "components/FormInput/FormInput";
import FormNumericInput from "components/FormInput/FormNumericInput";
import StyledFormBooleanCheckbox from "components/FormInput/FormBooleanCheckbox";

import { ReactComponent as ExpandIcon } from "assets/images/expand-icon.svg";

import { styles } from "./styles";

export const AdditionalSettings: React.FC = () => {
  const { watch } = useFormContext();

  const showNotes = watch("showNotes");
  const showClientNotes = watch("showClientNotes");
  const showExpiration = watch("showInvoiceExpiration");

  const requestPayerFullName = watch("requestPayerFullName");
  const requestOrderNumber = watch("requestOrderNumber");

  const [isOpen, setIsOpen] = useState<boolean>(
    showNotes ||
      showClientNotes ||
      showExpiration ||
      requestPayerFullName ||
      requestOrderNumber ||
      false,
  );

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <Stack direction="column">
      <Stack sx={styles.header} onClick={toggleOpen} role="button">
        <Typography variant="h5">Додаткові налаштування</Typography>
        <IconButton sx={styles.icon}>
          <ExpandIcon
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        </IconButton>
      </Stack>
      <Collapse in={isOpen}>
        <PaymentPurposeOptions />
        <StyledFormBooleanCheckbox
          name="showClientNotes"
          label="Додати нотатку для покупця"
          sx={{ mb: 0 }}
        />
        <Collapse in={showClientNotes}>
          <Box mt={1}>
            <StyledFormInput
              name="clientNotes"
              multiline
              rows={3}
              fullWidth
              slotProps={{ input: { inputProps: { maxLength: 70 } } }}
            />
          </Box>
        </Collapse>

        <StyledFormBooleanCheckbox
          name="showInvoiceExpiration"
          label="Встановити термін дії посилання"
          sx={{ mb: 0 }}
        />
        <Collapse in={showExpiration}>
          <Stack sx={styles.expirationContainer}>
            <FormNumericInput
              title="Дні"
              name="expirationDays"
              placeholder="Введіть кількість днів"
              fullWidth
              maxValue={1000}
              decimalScale={0}
            />
            <FormNumericInput
              title="Години"
              name="expirationHours"
              placeholder="Введіть кількість годин"
              fullWidth
              maxValue={1000}
              decimalScale={0}
            />
          </Stack>
        </Collapse>

        <StyledFormBooleanCheckbox
          name="showNotes"
          label="Додати персональну нотатку (покупець її не побачить)"
          sx={{ mb: 0 }}
        />
        <Collapse in={showNotes}>
          <Box mt={1}>
            <StyledFormInput
              name="notes"
              multiline
              rows={4}
              fullWidth
              slotProps={{ input: { inputProps: { maxLength: 512 } } }}
            />
          </Box>
        </Collapse>
      </Collapse>
    </Stack>
  );
};
